import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import PageSkeleton from "../components/PageSkeleton";
import routes from "./routes";

const AppRoutes = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Routes>
        {routes.map(({ path, element: Component }, i) => (
          <Route
            key={i}
            path={path}
            element={
              <Suspense fallback={<PageSkeleton />}>
                <Component />
              </Suspense>
            }
          />
        ))}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
